import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { v4 as uuidv4 } from 'uuid';
import { filesize } from 'filesize';
import { CommonService } from 'src/app/component/shared/services/common.service';
import * as SparkMD5 from 'spark-md5';
import {
  NgbmsMediaMgmtService,
  V1UploadVideoPost200Response,
} from 'src/app/component/shared/services/openapi/media-mgmt';
import { environment } from 'src/environments/environment';
import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
} from '@angular/common/http';
import { map, tap } from 'rxjs/operators';

type FileArr = {
  id: string;
  file: File;
  filesizeString: string;
};
@Component({
  selector: 'app-upload-video-modal',
  templateUrl: './upload-video-modal.component.html',
  styleUrls: ['./upload-video-modal.component.scss'],
})
export class UploadVideoModalComponent {
  files: FileArr[] = [];
  running: boolean = false;
  isUploaded: boolean = false;
  uploadedMessage: String = '';
  fileFormat: string = 'mp4';
  fileInputModel;

  filesizeLimit = 1000 ** 2 * 100; // 100 MB
  // filesizeLimit = 1000;
  filesizeLimitString = filesize(this.filesizeLimit, {
    output: 'string',
    standard: 'si',
  });

  constructor(
    private _commonService: CommonService,
    public dialogRef: MatDialogRef<UploadVideoModalComponent>,
    private _snackBar: MatSnackBar,
    private mediaMgmtService: NgbmsMediaMgmtService,
    private httpClient: HttpClient
  ) {}

  uploadFile(event: File[]) {
    console.log('Upload File', event, this.fileInputModel);
    this.isUploaded = false;
    this.files = [];
    if (event?.length > 0) {
      const fileList = Array.from(event).map(file => {
        const id = uuidv4();
        const filesizeString = filesize(file.size, { output: 'string' });
        return { id, file, filesizeString };
      });

      if (fileList[0] && fileList[0]?.file.size <= this.filesizeLimit) {
        const isValidFile = this.validateFile(fileList[0].file);

        if (isValidFile) {
          this.files = [fileList[0]];
        } else {
          this.fileInputModel = null;
          this._snackBar.open(
            `File (${fileList[0]?.file.name}) is not a valid video file.`,
            null,
            {
              duration: 3000,
              panelClass: 'custom-snack-bar-panel-error',
            }
          );
        }
      } else {
        if (fileList[0] && fileList[0]?.file.size > this.filesizeLimit)
          this._snackBar.open(
            `File (${fileList[0]?.filesizeString}) is larger than ${this.filesizeLimitString}.`,
            null,
            {
              duration: 3000,
              panelClass: 'custom-snack-bar-panel-error',
            }
          );
      }

      // this.files = [...this.files, ...fileList];
    }
  }

  validateFile(fileObj: File) {
    const acceptedTypes = ['mp4', 'm4v'];
    const acceptedTypesLong = ['video/mp4', 'video/m4v'];
    const nameExtension = fileObj.name.split('.').pop();
    if (!acceptedTypes.includes(nameExtension)) {
      return false;
    }
    if (!acceptedTypesLong.includes(fileObj.type)) {
      return false;
    }
    return true;
  }

  deleteAttachment(item) {
    const { id } = item;
    this.files = this.files.filter(item => item.id !== id);
    this.fileInputModel = undefined;
    console.log('Files: ', this.files, this.fileInputModel);
  }

  async btnUploadFile() {
    this.running = true;
    this.uploadedMessage = '';

    if (this.files === null || this.files?.length < 1) {
      this.running = false;
      return;
    }
    let body: any = new FormData();
    const currFile = this.files[0];

    // compute md5
    const fileBuffer = await currFile.file.arrayBuffer();
    // const spark = new SparkMD5.ArrayBuffer();
    // spark.append(fileBuffer);
    // const fileHash = spark.end();
    const fileHash = SparkMD5.ArrayBuffer.hash(fileBuffer);

    console.log('hash', fileHash, currFile);
    // body.append('videoFile', currFile.file);
    // body.append('checksum', fileHash);

    // const urlUploadFile = environment.apiUrl.devices + '/v1/uploadVideo';

    // this.httpClient
    //   .post(urlUploadFile, body, {
    //     headers: new HttpHeaders({ 'content-type': 'multipart/form-data' }),
    //     reportProgress: true,
    //     responseType: 'json',
    //   })
    //   .subscribe(
    //     (result: V1UploadVideoPost200Response) => {
    //       this.running = false;
    //       const { message } = result;
    //       this._snackBar.open(`${message}`, null, {
    //         duration: 3000,
    //       });
    //       this.dialogRef.close({ result });
    //     },
    //     e => {
    //       this.running = false;
    //       console.error('Failed to upload: ', e);
    //       this._snackBar.open(
    //         `Failed to upload file. Please try again.`,
    //         null,
    //         {
    //           duration: 3000,
    //           panelClass: 'custom-snack-bar-panel-error',
    //         }
    //       );
    //     }
    //   );

    // OPENAPI doesn't work for some reason
    this.mediaMgmtService
      .v1UploadVideoPost(
        undefined,
        undefined,
        currFile.file,
        fileHash,
        undefined,
        true
      )
      .subscribe(
        result => {
          console.log('result', result);
          this.running = false;
          const { message } = result;
          this._snackBar.open(`${message}`, null, {
            duration: 3000,
          });
          this.dialogRef.close({ result });
        },
        e => {
          this.running = false;
          console.error('Failed to upload: ', e);
          this._snackBar.open(
            `Failed to upload file. Please try again.`,
            null,
            {
              duration: 3000,
              panelClass: 'custom-snack-bar-panel-error',
            }
          );
        }
      );
  }

  /** Return distinct message for sent, upload progress, & response events */
  private getEventMessage(event: HttpEvent<any>, file: File) {
    switch (event.type) {
      case HttpEventType.Sent:
        return `Uploading file "${file.name}" of size ${file.size}.`;

      case HttpEventType.UploadProgress:
        // Compute and show the % done:
        const percentDone = event.total
          ? Math.round((100 * event.loaded) / event.total)
          : 0;
        return `File "${file.name}" is ${percentDone}% uploaded.`;

      case HttpEventType.Response:
        return `File "${file.name}" was completely uploaded!`;

      default:
        return `File "${file.name}" surprising upload event: ${event.type}.`;
    }
  }
}
